<template>
  <pane
    id="table-export"
    :title="$t('toolbar.export.title')"
    :label="$t('toolbar.export.label')"
    :icon="ExportIcon"
  >
    <ExportLink
      :url="url"
      :filter="filter"
      :columns="columns"
      :title="title"
      :visible-columns="visibleColumns"
      :label="$t('toolbar.export.downloadLabel')"
      :sort-key="sortKey"
      :sort-direction="sortDirection"
    />
    <ExportLink
      :url="url"
      :filter="filter"
      :columns="columns"
      :title="title"
      :visible-columns="visibleColumns"
      :label="$t('toolbar.export.downloadXlsxLabel')"
      :sort-key="sortKey"
      :sort-direction="sortDirection"
      format="xlsx"
      class="mt-5"
    />
    <slot />
  </pane>
</template>

<script lang="ts" setup>
import Pane from '@components/utils/toolbar/Pane.vue';
import ExportIcon from '@images/export.svg?component';
import ExportLink from '@utils/toolbar/panes/ExportLink.vue';
import type { Filter } from '../../table/hooks/provider';

interface Props {
  url: string;
  filter?: Filter;
  columns?: { key: string, title?: string, csvTranslations?: { [key: string]: string } }[];
  visibleColumns?: { [key: string]: boolean };
  title?: string;
  sortKey?: string;
  sortDirection?: 'ASC' | 'DESC';
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.link {
  @apply flex gap-x-3.5 items-center;
  @apply text-left text-body-regular font-normal;
  @apply cursor-pointer;

  max-width: px(350);

  label {
    @apply cursor-pointer;
  }
}
</style>
